import { AvailabilityColumns, LeaseColumns, PropertyColumns, SaleColumns, TimColumns } from '@miq/catalog';

export const EDITABLE_COLUMNS_BY_ID = {
  [TimColumns.TIMDetails_DealStatus]: false,
  [TimColumns.TIMDetails_TIMStatus]: false,
  [LeaseColumns.Property_PropertyID]: false,
  [LeaseColumns.LeaseCompDetails_RecordType]: false,
  [AvailabilityColumns.Property_PropertyID]: false,
  [PropertyColumns.PropertyComplexName]: false,
  [PropertyColumns.PropertyComplexYearBuilt]: false,
  [PropertyColumns.PropertyComplexNotes]: false,
  // Disabling Property's primary address columns, temporary change since needs to be revisited once
  // behavior is defined for Tri-state users
  // START
  [PropertyColumns.Address_Latitude]: false,
  [PropertyColumns.Address_Longitude]: false,
  [PropertyColumns.Address_Address]: false,
  [PropertyColumns.Address_City]: false,
  [PropertyColumns.Address_Country]: false,
  [PropertyColumns.Address_County]: false,
  [PropertyColumns.Address_PostStreetDirection]: false,
  [PropertyColumns.Address_PostalCode]: false,
  [PropertyColumns.Address_PreStreetDirection]: false,
  [PropertyColumns.Address_State]: false,
  [PropertyColumns.Address_Stree1]: false,
  [PropertyColumns.Address_StreetType]: false,
  [PropertyColumns.Address_Street_Name]: false,
  [PropertyColumns.AlternateAddress_Town]: false,
  // END
  [SaleColumns.Property_PropertyID]: false,
  [SaleColumns.Property_FloorCount]: false,
  [SaleColumns.Property_Campus]: false,
};
